
import { Payload } from "@/types/profile";

export const privacyPayloads: Payload[] = [
  // Privacy Preferences Policy Control payloads
  {
    id: "privacy-preferences",
    name: "Privacy Preferences Policy Control",
    description: "Configure privacy preferences policy control",
    category: "Security",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "identifier",
        name: "Application Identifier",
        type: "text",
        required: true,
        description: "Bundle identifier of the application"
      },
      {
        id: "codeRequirement",
        name: "Code Requirement",
        type: "textarea",
        required: true,
        description: "Code requirement for the application"
      },
      {
        id: "privacySettings",
        name: "Privacy Settings",
        type: "textarea",
        required: true,
        description: "Privacy settings in JSON format"
      }
    ]
  }
];
